module.exports = __webpack_public_path__ + "static/img/logo-xd.c0c96993.svg";